export default {
  section_title: 'Belastingafhandeling',
  inherited_from_partner: 'Overgenomen',
  inherited_from_region: 'Regionale standaard',
  reset: 'Terugzetten naar overgenomen',
  form: {
    tax_name: {
      label: 'Belastingnaam',
      tooltip: 'Hoe de belasting wordt genoemd op bonnen en facturen, bijvoorbeeld btw of GST.',
    },
    tax_behaviour: {
      label: 'Belastingafhandeling',
      tooltip: 'Of uw menuprijzen al belasting bevatten, of dat deze bij het afrekenen wordt toegevoegd.',
      options: {
        inclusive: 'Inbegrepen in menuprijzen',
        exclusive: 'Toegevoegd bij afrekenen',
      },
    },
    delivery_fee_tax_percentage: {
      label: 'Belastingtarief bezorgkosten',
      tooltip: 'Het tarief waartegen uw eigen bezorgkosten worden belast, dat kan afwijken van het tarief op het eten.',
    },
  },
  impact: {
    title: 'Belastingafhandeling wijzigen voor uw restaurants?',
    affected_one: '{{count}} restaurant volgt uw standaardinstelling en zal wijzigen.',
    affected_other: '{{count}} restaurants volgen uw standaardinstelling en zullen wijzigen.',
    overriding_one: '{{count}} restaurant heeft een eigen instelling en behoudt deze.',
    overriding_other: '{{count}} restaurants hebben een eigen instelling en behouden deze.',
    confirm: 'Wijzig ze',
  },
  buttons: {
    save: 'Opslaan',
    cancel: 'Annuleren',
  },
  toasts: {
    load_error: 'Belastinginstellingen laden mislukt',
    impact_error: 'Controleren welke restaurants dit zou wijzigen mislukt',
    impact_changed_one: 'Het aantal betrokken restaurants is gewijzigd naar {{count}}. Controleer en sla opnieuw op.',
    impact_changed_other: 'Het aantal betrokken restaurants is gewijzigd naar {{count}}. Controleer en sla opnieuw op.',
    failed_to_save_changes: 'Wijzigingen opslaan mislukt',
    changes_got_saved: 'Wijzigingen zijn opgeslagen',
  },
};
